<template>
    <div class="bg-white rounded-lg shadow p-4">
        <h3 class="text-sm font-medium text-gray-700 mb-3">시장 구분</h3>
        <div class="grid grid-cols-2 gap-2">
            <button @click="toggleFilter('secondary')" :class="[
                'px-3 py-1.5 text-sm font-medium rounded border transition-all',
                modelValue.secondary
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400',
            ]">
                <span class="flex items-center justify-center gap-1.5">
                    <svg v-if="modelValue.secondary" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>유통시장</span>
                </span>
            </button>
            <button @click="toggleFilter('primary')" :class="[
                'px-3 py-1.5 text-sm font-medium rounded border transition-all',
                modelValue.primary
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400',
            ]">
                <span class="flex items-center justify-center gap-1.5">
                    <svg v-if="modelValue.primary" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>발행시장</span>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MarketTypeFilter',
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const toggleFilter = (key) => {
            emit('update:modelValue', {
                ...props.modelValue,
                [key]: !props.modelValue[key],
            });
        };

        return {
            toggleFilter,
        };
    },
};
</script>
